module.exports = __webpack_public_path__ + "static/media/vacciplant.f94433bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/aguacate/climasense/antracnosis_aguacate/preventiva/vacciplant.png
// module id = 1088
// module chunks = 3